import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";
import CTASection from "../components/CTASection";
import NotFound from "./NotFound";
import { getResource } from "../lib/api";

export default function ResourceArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    setArticle(null);
    setMissing(false);
    getResource(slug).then(setArticle).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <NotFound />;
  if (!article) {
    return <div className="max-w-3xl mx-auto px-4 py-24 text-slate-500">Loading…</div>;
  }

  return (
    <>
      <SEO title={article.title} description={article.excerpt} path={`/resources/${article.slug}`} />
      <article className="bg-white" data-testid="resource-article">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-8 pb-16">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Resources", to: "/resources" }, { label: article.title }]} />
          <header className="mt-8">
            <time className="text-sm text-slate-400 font-medium">{article.date}</time>
            <h1 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl text-slate-900 leading-[1.1] mt-2">{article.title}</h1>
          </header>
          {article.image && (
            <img src={article.image} alt={article.title} className="w-full aspect-[16/8] object-cover rounded-xl mt-8" loading="lazy" />
          )}
          <div className="mt-8 space-y-6">
            {article.body.map((block, i) => (
              <section key={i}>
                {block.heading && <h2 className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mb-2">{block.heading}</h2>}
                <p className="text-slate-600 leading-relaxed">{block.text}</p>
              </section>
            ))}
          </div>
          <Link to="/resources" className="inline-flex items-center gap-2 mt-10 text-sm font-heading font-semibold text-sky-700 hover:text-sky-800" data-testid="article-back">
            <ArrowLeft className="h-4 w-4" /> Back to Resources
          </Link>
        </div>
      </article>
      <CTASection />
    </>
  );
}
